/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiUserActionUserFromJSON, ApiUserActionUserToJSON, } from './ApiUserActionUser';
export function ApiGetUsersResponseFromJSON(json) {
    return ApiGetUsersResponseFromJSONTyped(json, false);
}
export function ApiGetUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nextPageToken': !exists(json, 'nextPageToken') ? undefined : json['nextPageToken'],
        'users': !exists(json, 'users') ? undefined : (json['users'].map(ApiUserActionUserFromJSON)),
    };
}
export function ApiGetUsersResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'nextPageToken': value.nextPageToken,
        'users': value.users === undefined ? undefined : (value.users.map(ApiUserActionUserToJSON)),
    };
}
